import { render, staticRenderFns } from "./FieldPriority.vue?vue&type=template&id=63e137f8&scoped=true&"
import script from "./FieldPriority.vue?vue&type=script&lang=js&"
export * from "./FieldPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e137f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e137f8')) {
      api.createRecord('63e137f8', component.options)
    } else {
      api.reload('63e137f8', component.options)
    }
    module.hot.accept("./FieldPriority.vue?vue&type=template&id=63e137f8&scoped=true&", function () {
      api.rerender('63e137f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldPriority.vue"
export default component.exports